import Link from "next/link";

import { Button, Card, Skeleton } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { useUserInfoQuery } from "@chef/state-management";
import { useTrack } from "@chef/state-management/hooks";

import { MyAccountLayout } from "../../components/MyAccountLayout";

import { intl } from "./MyAccountAccountInformationPage.Intl";

export const MyAccountAccountInformationPage = () => {
  const { data: userInfoQuery, isLoading } = useUserInfoQuery();

  const track = useTrack();

  return (
    <MyAccountLayout page="accountInformation">
      <section
        className="col-span-5 space-y-6"
        id="my-account-personal-information-card-grid"
      >
        <Card>
          <div className="flex justify-between">
            <h3 className="lg:text-xl">
              <strong>{intl.PERSONAL_INFORMATION}</strong>
            </h3>
            <Link
              href={BRAND_PATHS.CHANGE_PERSONAL_INFORMATION_LINK}
              passHref
              legacyBehavior
            >
              <Button
                tiny
                outlined
                id="my-account-edit-personal-information-page-button"
              >
                {intl.EDIT_BUTTON}
              </Button>
            </Link>
          </div>
          <ul className="mt-6">
            <li>
              <strong>
                {isLoading ? (
                  <div className="flex flex-col gap-1">
                    <Skeleton width={32} height={5} />
                    <Skeleton width={40} height={5} />
                    <Skeleton width={32} height={5} />
                  </div>
                ) : (
                  `${userInfoQuery?.userInfo.firstName} ${userInfoQuery?.userInfo.lastName}`
                )}
              </strong>
            </li>
            <li>{userInfoQuery?.userInfo.email}</li>
            <li>{userInfoQuery?.userInfo.telephone}</li>
          </ul>
        </Card>
        <Card>
          <div className="flex justify-between">
            <h3 className="lg:text-xl">
              <strong>{intl.PASSWORD}</strong>
            </h3>
            <Link
              href={BRAND_PATHS.CHANGE_PASSWORD_LINK}
              passHref
              legacyBehavior
            >
              <Button tiny outlined id="my-account-edit-account-info-button">
                {intl.EDIT_BUTTON}
              </Button>
            </Link>
          </div>
          <ul className="mt-6">
            <li>
              <strong>{intl.CURRENT_PASSWORD}</strong>
            </li>
            {isLoading ? (
              <Skeleton height={5} width={20} />
            ) : (
              <li>•••••••••</li>
            )}
          </ul>
        </Card>
        <Card>
          <div className="flex justify-between">
            <h3 className="lg:text-xl">
              <strong>{intl.CONSENTS}</strong>
            </h3>

            <Button
              href={BRAND_PATHS.CHANGE_CONSENTS_LINK}
              tiny
              outlined
              id="my-account-edit-consents-button"
            >
              {intl.EDIT_BUTTON}
            </Button>
          </div>
          <p className="mt-6 text-base">{intl.CONSENTS_DESCRIPTION}</p>
        </Card>
        <div className="text-center">
          <Link
            href={BRAND_PATHS.DELETE_ACCOUNT_LINK}
            passHref
            className="text-base underline text-error"
            onClick={() =>
              track("accountDeletionClicked", {
                affiliation: "Frontend process",
              })
            }
          >
            {intl.DELETE_ACCOUNT}
          </Link>
        </div>
      </section>
    </MyAccountLayout>
  );
};
